import { StyleSheet } from 'react-native'
import theme from '../../../theme'
import { colorFilterTextSelected, colorFilterTextUnselected, colorText } from '../../../themeConstants'

const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    containerLabels: {
        backgroundColor: 'white',
        height: 34,
        marginHorizontal: 4,
        marginVertical: 5,
        justifyContent: 'space-between',
    },
    flatFlags: {
        flexDirection: 'row',
        borderRadius: 5,
        borderWidth: 0.5,
        borderColor: theme.colors.textPrimary,
        paddingHorizontal: 15,
        height: 30,
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
    },
    flatItemsSelected: {
        fontSize: 15,
        fontWeight: 'bold',
        color: 'white',
    },
    flatItemsUnselected: {
        fontSize: 15,
        fontWeight: 'bold',
        color: theme.colors.textPrimary,
    },
    flatFlagsPrimary: {
        flexDirection: 'row',
        borderRadius: 10,
        borderWidth: 0.5,
        borderColor: theme.colors.colorPrimary,
        paddingHorizontal: 15,
        height: 30,
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
    },
    flatItemsSelectedPrimary: {
        fontSize: 15,
        fontWeight: 'bold',
        color: colorFilterTextSelected,
    },
    flatItemsUnselectedPrimary: {
        fontSize: 15,
        fontWeight: 'bold',
        color: colorFilterTextUnselected,
    },
})

export default styles
